import { Badge, Box, IconButton, Typography, List, ListItem, ListItemText, ListItemSecondaryAction, ListItemAvatar, Divider, Button, Dialog, DialogActions, DialogTitle, DialogContent, ListItemIcon, Collapse, Link } from '@mui/material';
import { CreditCard, Delete, Edit, ExpandLess, ExpandMore, LocalShipping, ShoppingCart } from '@mui/icons-material';
import React, { useContext, useEffect, useState } from 'react';
import { Drawer } from '@mui/material';
import __t from '../lib/traduzioni';
import BSSPreventivoContext from '../contexts/BSSPreventivoContext'
import Wrapper from './Wrapper';
import { useLocalStorage } from 'react-use';
import { useTheme } from '@mui/material';

import useBSSLogger from '../hooks/useBSSLogger';
import { labelLocalita, nextUrlByStep } from './preventivo/frammenti/FrammentoRiepilogo';
import useSWRImmutable from 'swr/immutable';
import DefaultLoadingComponent from './form/DefaultLoadingComponent';
import { retrieveTipispedizione } from '../api/tipospedizione';
import currencies from '../currencies';

import PersonPin from '@mui/icons-material/PersonPin';


const {logger} = useBSSLogger();

import { format, parse } from 'date-fns';
import { NoPreviousData } from './preventivo/Preventivo';

const MenuAccount = () => {  
    
    const theme = useTheme()


    const [open, setOpen] = useState(false)

    if(!spedizioniweb2?.isloggedin()){
        return (
            <>
                <Link component={IconButton} href={spedizioniweb2?.loginurl ?? "#"}>
                    <PersonPin />
                </Link>
            </>
        )
    }

    return (
        
        <>
            <List
                component="nav"                
            >
                <ListItem button onClick={e => setOpen(!open)}>
                    <PersonPin />
                    {/* {open ? <ExpandLess /> : <ExpandMore />} */}
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit style={{position: "absolute", zIndex: 9999, backgroundColor: theme.palette.background.default}}>
                    <List component="div" disablePadding>
                        <ListItem button >
                            {/* <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon> */}
                            <ListItemText primary={__t("datifatturazione")} />
                        </ListItem>
                        <ListItem button >
                            {/* <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon> */}
                            <ListItemText primary={__t("rubrica")} />
                        </ListItem>
                        <ListItem button >
                            {/* <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon> */}
                            <ListItemText primary={__t("storicoordini")} />
                        </ListItem>
                        <ListItem button >
                            {/* <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon> */}
                            <ListItemText primary={__t("preferenze")} />
                        </ListItem>
                        
                    </List>
                </Collapse>
            </List>
            

        </>
    )
}

export default MenuAccount;
